import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import NextIcon from "@material-ui/icons/SkipNext";
import PrevIcon from "@material-ui/icons/SkipPrevious";
import BackIcon from "@material-ui/icons/KeyboardBackspace";
import EyeIcon from "@material-ui/icons/RemoveRedEye";
import CloseIcon from "@material-ui/icons/Close";
import CorrectIcon from "@material-ui/icons/Done";
import IncorrectIcon from "@material-ui/icons/Clear";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import SpeakerButton from "@material-ui/icons/VolumeUp";
import { img, staticsUrl } from "../../config";

const useStyles = makeStyles((theme) => ({
  exercise: {
    "& button": {
      cursor: "pointer",
    },
    "& h3": {
      textAlign: "center",
      marginBottom: "0.5em",
    },
    "& p": {
      textAlign: "center",
      marginTop: 0,
    },
  },
  exerciseInner: {
    // background: '#ecf1ff',
  },
  menu: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    width: "100%",
    "& > div": {
      overflowY: "auto",
      margin: "20px 0",
      maxWidth: "100%",
      "& > div": {
        border: "3px solid #C3CCE9",
        width: 400,
        maxWidth: "100%",
        textAlign: "center",
        cursor: "pointer",
        borderRadius: 5,
        marginBottom: 5,
        padding: 5,
        background: "#fff",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 45,
        flexDirection: "column",
        "&:hover": {
          background: "#EFF3FA",
        },
      },
    },
    "& p": {
      lineHeight: 1,
      margin: "2px 0",
    },
  },
  intro: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    width: 600,
    maxWidth: "100%",
    margin: "0 auto",
    "& > div": {
      overflow: "auto",
      margin: "20px 0",
      width: "100%",
      textAlign: "center",
    },
    "& p": {
      lineHeight: 1,
      margin: "0 0 3px",
    },
  },
  introTitle: {
    maxWidth: "100%",
    textAlign: "center",
    borderRadius: 5,
    marginBottom: 5,
    padding: 5,
    lineHeight: 1,
    "& p": {
      fontSize: "20px !important",
    },
    "& span": {
      fontSize: "20px !important",
    },
  },
  introAction: {
    textAlign: "center",
    "& button": {
      margin: "0 1px",
    },
    "& > div": {
      display: "inline-block",
      padding: "0.25em 1em",
      color: "#a1008f",
      verticalAlign: "middle",
      margin: "0 1px",
      borderRadius: 3,
    },
  },
  introBody: {
    marginBottom: 20,
    display: "inline-block",
    textAlign: "center",
    border: "5px solid #9cdfff",
    padding: 20,
    borderRadius: 10,
    boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.3)",
    maxWidth: "100%",
    background: "#fff",
    userSelect: "none",
    minWidth: 200,
    minHeight: 100,
  },
  imgWrap: {
    maxWidth: "100%",
    overflow: "auto",
    "& > img": {
      marginBottom: 20,
      maxWidth: "100%",
    },
  },
  quiz: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    height: "100%",
    "& > div": {
      position: "relative",
      overflow: "auto",
      margin: "20px 0",
      textAlign: "center",
      width: 500,
      maxWidth: "100%",
      background: "#fff",
      padding: 20,
    },
    "& p": {
      margin: "0 0 0.5em",
    },
  },
  quizDesc: {
    margin: "14px 0",
    lineHeight: 1.3,
  },
  qPagination: {
    color: "#666",
    fontWeight: 600,
  },
  quizAction: {
    textAlign: "center",
    marginTop: 20,
    "& button": {
      margin: "0 1px",
    },
    "& > div": {
      display: "inline-block",
      padding: "0.25em 1em",
      color: "#a1008f",
      verticalAlign: "middle",
      margin: "0 1px",
      borderRadius: 3,
    },
  },
  glance: {
    display: "inline-block",
    padding: "0 0.5em",
    verticalAlign: "middle",
    cursor: "pointer",
    color: "#777",
    transition: "color 0.3s",
    "&:hover": {
      color: "green",
    },
  },
  isCorrect: {
    display: "inline-block",
    width: 50,
    textAlign: "center",
  },
  action: {
    textAlign: "center",
    marginTop: 20,
  },
  preview: {
    display: "inline-block",
    width: "100%",
    border: "1px solid #666",
    borderRadius: 3,
    padding: "3px 10px",
    fontSize: 16,
    textAlign: "center",
    color: "green",
    boxSizing: "border-box",
  },
  input: {
    display: "flex",
    width: 400,
    maxWidth: "100%",
    margin: "10px auto",
    justifyContent: "center",
    alignItems: "center",
    "& input": {
      width: "100%",
      border: "1px solid #666",
      borderRadius: 3,
      padding: "5px 10px",
      fontSize: 16,
      textAlign: "center",
      boxSizing: "border-box",
    },
  },
  textSpeach: {
    background: "#eee",
    padding: "0 20px",
    borderRadius: 5,
  },
  quizIntro: {
    background: "#efefef",
    borderRadius: 5,
    padding: "20px 10px 5px",
    marginBottom: 20,
  },
  closeQuiz: {
    position: "absolute",
    top: 0,
    right: 0,
    color: "#999",
    transition: "color 0.3s",
    cursor: "pointer",
    "&:hover": {
      color: "#333",
    },
  },
}));

let timeout1 = 0;
let timeout2 = 0;

function HowLangWorks(props) {
  const classes = useStyles();
  const [state, setState] = useState("menu");
  const [no, setNo] = useState(0);
  const [subject, setSubject] = useState(0);
  const [exerciseArr, setExerciseArr] = useState([]);
  const { exercise, startStats, finishExercise, action, type } =
    props.exerciseProps;
  const [answer, setAnswer] = useState("");
  const [isCorrect, setIsCorrect] = useState(null);
  const [preview, setPreview] = useState(false);
  const [testFinished, setTestFinished] = useState(false);
  const [showQuizBtn, setShowQuizBtn] = useState(false);
  const inputRef = useRef(null);
  const data = exerciseArr[subject];
  // eslint-disable-next-line
  // const refs = new Array(9).fill(null).map(el => useRef(null));

  useEffect(() => {
    startStats(type);
    finishExercise();
    return () => {
      clearTimeout(timeout1);
      clearTimeout(timeout2);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setExerciseArr(processData(exercise));
  }, [exercise]);

  useEffect(() => {
    if (answer === "") setFocus();
  }, [answer]);

  const setFocus = () => inputRef.current && inputRef.current.focus();
  const play = (url) => {
    action();
    props.media.play(url);
  };

  const drawMenu = () => {
    const runIntro = (idx) => {
      setNo(0);
      setState("intro");
      setSubject(idx);
      setShowQuizBtn(false);
    };
    return (
      <div className={classes.menu}>
        <div>
          {exerciseArr.map((data, idx) => (
            <div
              key={data.name}
              dangerouslySetInnerHTML={{ __html: data.title }}
              onClick={() => runIntro(idx)}
            />
          ))}
        </div>
      </div>
    );
  };

  const drawIntro = () => {
    const pages = data.elements[no];
    const len = data.elements.length;
    const next = () => {
      if (no < len - 1) setNo(no + 1);
      if (no === len - 2) setShowQuizBtn(true);
      action();
    };
    const prev = () => {
      if (no > 0) setNo(no - 1);
      action();
    };
    const startQuiz = () => {
      setAnswer("");
      setIsCorrect(null);
      setState("quiz");
      setNo(0);
      setTestFinished(false);
      action();
    };

    return (
      <div className={classes.intro}>
        <div>
          <div
            className={classes.introTitle}
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
          <div className={classes.introBody}>
            {Boolean(pages) && pages.map(drawElement)}
          </div>
          <div className={classes.introAction}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => setState("menu")}
            >
              <BackIcon />
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={prev}
              disabled={no === 0}
            >
              <PrevIcon />
            </Button>
            <div>
              {no + 1}/{len}{" "}
            </div>
            <Button
              variant="outlined"
              color="secondary"
              onClick={next}
              disabled={no === len - 1}
            >
              <NextIcon />
            </Button>
            {data.questions.length > 0 && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={startQuiz}
                disabled={!showQuizBtn || data.questions.length === 0}
              >
                Quiz
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  };

  const drawElement = (el) => {
    switch (el.type) {
      case "IMAGE":
        const imgUrl = `${staticsUrl + el.imageUrl}`;
        return (
          <div key={el.imageUrl} className={classes.imgWrap}>
            <img src={imgUrl} alt="" />
          </div>
        );
      case "MODEL":
        const soundUrl = `${staticsUrl + el.soundUrl}`;
        return (
          <div className={classes.textSpeach} key={el.soundUrl}>
            <div dangerouslySetInnerHTML={{ __html: el.text }} />
            <IconButton
              className={classes.qIcon}
              onClick={() => play(soundUrl)}
            >
              <SpeakerButton />
            </IconButton>
          </div>
        );
      default:
        console.log("unknown element", el);
    }
  };

  const drawQuiz = () => {
    const question = data.questions[no];
    const len = data.questions.length;

    const next = () => {
      action();
      if (no < len - 1) {
        setNo(no + 1);
        setAnswer("");
        setIsCorrect(null);
      } else {
        finishTest();
      }
    };

    const cleanString = (str) => {
      if (str.indexOf(".") === str.length - 1) {
        str = str.substr(0, str.length - 1);
      }
      return str.trim().toLowerCase();
    };

    const checkAnswer = () => {
      action();
      const ok = cleanString(question.answer) === cleanString(answer);
      if (ok) {
        correct();
      } else {
        incorrect();
      }
    };
    const correct = () => {
      props.media.success();
      setIsCorrect(true);
      timeout2 = setTimeout(() => {
        next();
      }, 2000);
    };
    const incorrect = () => {
      props.media.failure();
      setIsCorrect(false);
    };
    const showPreview = () => {
      action();
      setPreview(true);
      timeout1 = setTimeout(() => {
        setPreview(false);
      }, 2000);
    };
    const handleKeyDown = (ev) => {
      action();
      if (ev.key === "Enter") checkAnswer();
    };
    const finishTest = () => {
      setTestFinished(true);
      props.media.finish();
    };
    const pagination = no + 1 + "/" + len;
    return (
      <div className={classes.quiz}>
        <div>
          <IconButton
            className={classes.closeQuiz}
            onClick={() => setState("intro")}
          >
            <CloseIcon />
          </IconButton>

          <div className={classes.quizIntro}>
            <div
              className={classes.introTitle}
              dangerouslySetInnerHTML={{ __html: data.title }}
            />
            <p className={classes.quizDesc}>{data.quiz}</p>
            <p className={classes.qPagination}>{pagination}</p>
          </div>

          <p>{question.example}</p>
          <p>{question.prefix}</p>
          <div className={classes.input}>
            <div className={classes.glance} onClick={showPreview}>
              <EyeIcon />
            </div>
            {!preview && (
              <input
                type="text"
                value={answer}
                onChange={(ev) => setAnswer(ev.target.value)}
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck={false}
                onKeyDown={handleKeyDown}
                ref={inputRef}
              />
            )}
            {preview && (
              <div className={classes.preview}>{question.answer}</div>
            )}
            <div className={classes.isCorrect}>
              {isCorrect && (
                <span style={{ color: "green" }}>
                  <CorrectIcon />
                </span>
              )}
              {isCorrect === null && <span style={{ color: "green" }}>?</span>}
              {isCorrect === false && (
                <span style={{ color: "red" }}>
                  <IncorrectIcon />
                </span>
              )}
            </div>
          </div>
          <p>{question.suffix}</p>
          <div className={classes.quizAction}>
            {!testFinished && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={checkAnswer}
                disabled={preview || !answer}
              >
                Sprawdź
              </Button>
            )}
            {testFinished && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setState("menu")}
              >
                Powrót do menu
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {state === "menu" && drawMenu()}
      {state === "intro" && drawIntro()}
      {state === "quiz" && drawQuiz()}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  };
};

function toArray(obj) {
  const arr = [];
  for (let key in obj) arr.push(obj[key]);
  return arr;
}

function processData(obj) {
  return toArray(obj).map((exercise) => {
    const elements = [];
    let elementData = [];
    exercise.elements.forEach((element) => {
      if (element.type === "NEW_PAGE") {
        elements.push(elementData);
        elementData = [];
      } else {
        elementData.push(element);
      }
    });
    if (elementData.length > 0) elements.push(elementData);
    return { ...exercise, elements };
  });
}

export default connect(mapStateToProps)(HowLangWorks);
